import React from "react";

import { DollarSignIcon, InfoIcon } from "lucide-react";

import { Card, CardContent } from "~/components/ui/card";

interface UnidentifiedPaymentsSummaryProps {
  count: number;
  totalAmount: number;
}

export default function UnidentifiedPaymentsSummary({
  count,
  totalAmount,
}: UnidentifiedPaymentsSummaryProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }).format(amount);
  };

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <Card>
        <CardContent className="flex items-center p-6">
          <div className="mr-4 rounded-full bg-blue-100 p-3">
            <InfoIcon className="h-6 w-6 text-blue-700" />
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">
              Número de transacciones no reconocidas
            </p>
            <h3 className="text-2xl font-bold">{count}</h3>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="flex items-center p-6">
          <div className="mr-4 rounded-full bg-green-100 p-3">
            <DollarSignIcon className="h-6 w-6 text-green-700" />
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">
              Monto de transacciones no reconocidas
            </p>
            <h3 className="text-2xl font-bold">
              {formatCurrency(totalAmount)}
            </h3>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
